module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#arrow",
      toString: function () {
        return this.url;
      }
    }